import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IPopupSFilter } from 'src/@types/SearchFilterTypes';

import { Page } from '../../../components/Page';

import PopupGrid from './PopupGrid';
import SearchForm from './SearchForm';
/** * ## Popup 설명 * */
export const Popup = observer(() => {
  // 검색 조건
  const [searchData, setSearchData] = useState<IPopupSFilter>({} as IPopupSFilter);
  // 목록 검색
  const onSearch = (data: IPopupSFilter) => {
    setSearchData(data);
  };
  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <PopupGrid searchData={searchData} />
    </Page>
  );
});
export default Popup;
